import React from "react";

const SheetContent = () => {
  return (
    <div>
      <table className="w-full">
        <tbody>
          <tr>
            <td className="w-1/3 font-bold">Compositions</td>
            <td>Polyester</td>
          </tr>
          <tr>
            <td className="w-1/3 font-bold">Styles</td>
            <td>Girly</td>
          </tr>
          <tr>
            <td className="w-1/3 font-bold">Properties</td>
            <td>Short Dress</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SheetContent;
